<template>
  <div class="ds-control ds-form-item ds-system" :class="getCss">
    <template v-if="simple && !isDesign">{{ value }}</template>
    <template v-else>
      <!-- <label v-if="showLabel" class="ds-form-label" :style="getLabelWidthStyle()">{{ label }}</label> -->
      <DsfFieldLabel
        v-if="showLabel"
        :mode="showDataCaptionMode"
        :style="getLabelWidthStyle()"
        :show-icon="showDataCaptionIcon" 
        :trigger="showDataCaptionTrigger"
        :data-caption="dataCapion"
        :is-design="isDesign"
        :owner="_self">
        {{ $t(label) }}
      </DsfFieldLabel>
      <div class="ds-form-block" :style="getFormItemBlockMarginLeft()">
        <template v-if="isDesign">
          [当前用户id]
        </template>
        <template v-else>
          {{ value }}
        </template>
      </div>
    </template>
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfUpdateUserId",
  mixins: [$mixins.formControl],
  ctrlCaption: "修改人ID",
  props: {
    caption: {
      type: String,
      default: dsf.config.kw.updateuserid,
    },
    label: {
      type: String,
      default: "修改人ID",
    },
    simple: {
      type: Boolean,
      default: false,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    allowPost:{
      type:Boolean,
      default:false
    },
    metadata: {
      type: Object,
      default() {
        return dsf.metadata.get("system-meta-data", {
          code: dsf.config.kw.updateuserid,
          valueAttributes: [
            {
              name: "修改人ID",
              code: dsf.config.kw.updateuserid,
              type: dsf.metadata.getDataType("string"),
              length: "50",
              defaultValue: null,
              unit: null,
            },
          ],
        });
      },
    },
  },
});
</script>
